var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMaintenance = function SvgMaintenance(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.6,251.91c-4.93,41.8-24,90.41-62.14,112.73-57.59,33.75-52.77,85.64-165.19,108.2a231.26,231.26,0,0,1-49.84,4.71,194.66,194.66,0,0,1-24.47-2C94.51,465.12,46.43,415.46,28.79,355.5,5.58,276.66,51.93,225,82.65,193.94s53.23-128,163.57-151A223.75,223.75,0,0,1,297.45,38c39.26,1,82.08,13.86,111.71,40.76q3.33,3,6.5,6.28C456.84,127.33,474.34,194.92,467.6,251.91Z",
    style: {
      fill: "#FEE900"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.6,251.91c-4.93,41.8-24,90.41-62.14,112.73-57.59,33.75-52.77,85.64-165.19,108.2a231.26,231.26,0,0,1-49.84,4.71,194.66,194.66,0,0,1-24.47-2C94.51,465.12,46.43,415.46,28.79,355.5,5.58,276.66,51.93,225,82.65,193.94s53.23-128,163.57-151A223.75,223.75,0,0,1,297.45,38c39.26,1,82.08,13.86,111.71,40.76q3.33,3,6.5,6.28C456.84,127.33,474.34,194.92,467.6,251.91Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.26,265.78C25.37,267.14,33,267,33,267s-1.64-5-1.78-5.28C29.53,258.2,24.25,252.44,20,253a5.13,5.13,0,0,0-4.12,6.42C16.56,262.42,19.61,264.63,22.26,265.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.88,287.81c3.23.47,10-1.5,10.55-1.65a91.77,91.77,0,0,0,4.12,11.39c.93,2.16,1.94,4.31,3,6.45-.62-.91-1.18-1.72-1.27-1.82-2.53-2.93-9.14-7.09-13.13-5.4a5.12,5.12,0,0,0-2.27,7.29c1.47,2.68,5,4,7.86,4.42s8.72-1.14,10.25-1.57c.41.81.81,1.63,1.22,2.45,2,3.91,3.94,7.81,5.76,11.69.65,1.37,1.23,2.74,1.82,4.11-.55-.81-1-1.48-1.11-1.58-2.53-2.92-9.14-7.09-13.13-5.39a5.13,5.13,0,0,0-2.27,7.28c1.47,2.68,5,4,7.86,4.42s8.15-1,10-1.49c.56,1.42,1.13,2.84,1.6,4.24.31,1,.67,1.87.92,2.86s.54,1.93.81,2.88c.44,1.85.91,3.76,1.3,5.57.28,1.27.52,2.47.77,3.69-.62-1.37-1.9-4-2-4.23-2.05-3.28-8-8.4-12.16-7.33A5.14,5.14,0,0,0,42,343c1,2.87,4.34,4.72,7.1,5.56,3.05.93,9.78.08,10.62,0,.41,2,.78,4,1.1,5.83.73,4.1,1.27,7.77,1.68,10.88h2.84c-.49-3.22-1.14-7.05-2-11.35-.41-2-.88-4.22-1.38-6.46a55.55,55.55,0,0,0,5.93-2.78c2.21,2.4,7.9,5.21,8.63,5.57-.77,1.9-1.54,3.74-2.3,5.47-1.57,3.61-3.06,6.82-4.38,9.55h3.07c1.13-2.52,2.38-5.38,3.68-8.55.79-1.93,1.6-4,2.41-6.15.82.17,7.48,1.53,10.59.83,2.82-.64,6.24-2.23,7.5-5a5.14,5.14,0,0,0-2.83-7.09c-4.11-1.38-10.38,3.29-12.68,6.4-.13.18-1.38,2.34-2.14,3.71.32-.87.65-1.72,1-2.62.65-1.79,1.25-3.59,1.91-5.53.28-.95.57-1.9.85-2.87s.51-2,.78-3c.56-2.34,1-4.75,1.41-7.18,1.56.57,7.15,2.52,10,2.31s6.5-1.26,8.17-3.82a5.14,5.14,0,0,0-1.73-7.44c-3.85-2-10.75,1.68-13.49,4.41-.17.17-1.92,2.35-2.86,3.56.23-1.46.47-2.92.65-4.41.54-4.29.94-8.66,1.37-13,.13-1.34.27-2.66.41-4,.56.21,7.15,2.66,10.39,2.44,2.89-.21,6.5-1.27,8.17-3.83a5.12,5.12,0,0,0-1.72-7.43c-3.85-2-10.76,1.67-13.5,4.4-.2.21-2.71,3.35-3.31,4.18.31-2.93.64-5.84,1.09-8.7a89.63,89.63,0,0,1,2.5-11.45c.25.1,7.12,2.7,10.45,2.46,2.88-.2,6.5-1.26,8.16-3.82a5.13,5.13,0,0,0-1.72-7.44c-3.85-2-10.75,1.68-13.5,4.41-.21.21-2.91,3.59-3.36,4.24.07-.22.11-.45.18-.67a66.15,66.15,0,0,1,4.53-10.82c1-1.93,2-3.72,3.1-5.44,1.23.62,6.88,3.36,9.89,3.48s6.6-.54,8.54-2.9a5.13,5.13,0,0,0-.89-7.58c-3.62-2.4-10.88.49-13.9,2.9-.17.13-1.69,1.65-2.79,2.77.49-.77,1-1.57,1.47-2.3,1.81-2.73,3.64-5.11,5.27-7.22.94-1.18,1.82-2.24,2.65-3.22,1.52,0,7.65-.21,10.33-1.47s5.61-3.52,6.24-6.51a5.13,5.13,0,0,0-4.29-6.31c-4.31-.47-9.43,5.44-11,9-.14.31-1.71,5.33-1.64,5.33h.1c-.82.92-1.68,1.92-2.6,3-1.69,2.07-3.57,4.42-5.45,7.12a90.82,90.82,0,0,0-5.65,9,67.42,67.42,0,0,0-4.83,10.87,1,1,0,0,1,0,.14c0-1.27,0-4.82-.07-5.1-.49-3.83-3.71-10.95-8-11.74a5.12,5.12,0,0,0-5.91,4.82c-.25,3,2,6.1,4.11,8,2.43,2.18,9.18,4.28,9.72,4.44a89.87,89.87,0,0,0-2.85,11.77c-.42,2.32-.76,4.67-1.08,7,0-1.1,0-2.08,0-2.22-.5-3.84-3.72-11-8-11.74a5.12,5.12,0,0,0-5.91,4.82c-.25,3,2,6.1,4.11,8s7.91,3.86,9.43,4.35c-.12.9-.24,1.81-.35,2.71-.52,4.35-1,8.69-1.64,12.94-.21,1.49-.48,3-.75,4.42,0-1,0-1.79,0-1.92-.5-3.83-3.71-11-8-11.74a5.13,5.13,0,0,0-5.92,4.82c-.25,3.05,2,6.1,4.12,8s7.35,3.68,9.15,4.26c-.32,1.49-.63,3-1,4.42-.27,1-.47,1.93-.81,2.9s-.61,1.9-.91,2.84c-.66,1.79-1.32,3.64-2,5.37-.47,1.21-.93,2.35-1.39,3.5.23-1.49.63-4.41.63-4.65A19.89,19.89,0,0,0,74.76,335a6.07,6.07,0,0,0-.07-1.13,5.12,5.12,0,0,0-6.27-4.35c-4.18,1.11-6.84,8.46-7,12.33,0,.22.14,2.71.26,4.28-.21-.91-.41-1.8-.63-2.73-.44-1.86-.94-3.69-1.46-5.67-.28-.94-.57-1.9-.87-2.86s-.67-2-1-2.93c-.83-2.26-1.77-4.52-2.78-6.77,1.62-.39,7.35-1.85,9.66-3.62s4.72-4.63,4.7-7.69a5.12,5.12,0,0,0-5.54-5.25c-4.31.47-8,7.33-8.83,11.12,0,.23-.3,3-.41,4.55-.62-1.35-1.22-2.7-1.89-4-1.93-3.88-4-7.74-6-11.61-.63-1.18-1.24-2.37-1.86-3.55.58-.14,7.43-1.73,10-3.71,2.3-1.75,4.73-4.63,4.71-7.69a5.13,5.13,0,0,0-5.54-5.25c-4.31.47-8,7.33-8.83,11.12-.06.28-.42,4.29-.46,5.31-1.36-2.61-2.69-5.23-3.89-7.86a90.22,90.22,0,0,1-4.23-10.92c.27-.06,7.43-1.69,10.07-3.72,2.3-1.76,4.73-4.63,4.71-7.69a5.13,5.13,0,0,0-5.54-5.25c-4.31.47-8,7.33-8.83,11.12-.06.3-.45,4.6-.46,5.39-.07-.22-.16-.44-.22-.65A66,66,0,0,1,34,273.79c-.24-2.16-.35-4.23-.41-6.24,1.36-.17,7.59-1,10.17-2.56s5.21-4.09,5.52-7.13A5.13,5.13,0,0,0,44.33,252c-4.33,0-8.8,6.4-10,10.08-.07.2-.5,2.31-.8,3.85,0-.91,0-1.85,0-2.72,0-3.28.22-6.28.42-8.93.13-1.51.28-2.88.43-4.15,1.25-.86,6.26-4.4,7.8-6.93s2.74-6,1.61-8.87a5.13,5.13,0,0,0-7-2.9c-3.85,2-4.87,9.74-4.23,13.56.06.32,1.51,5.38,1.58,5.34l.07-.05c-.17,1.22-.33,2.53-.49,4-.26,2.66-.54,5.66-.61,9a89.84,89.84,0,0,0,.25,10.62,67.16,67.16,0,0,0,2,11.73l0,.13c-.68-1.07-2.69-4-2.87-4.21-2.53-2.92-9.14-7.09-13.13-5.39A5.13,5.13,0,0,0,17,283.39C18.5,286.07,22,287.4,24.88,287.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.18,267.46c.07,0,1.38-5.06,1.43-5.39.53-3.83-.69-11.55-4.59-13.43a5.13,5.13,0,0,0-7,3.09c-1,2.87.28,6.4,1.85,8.82C92.74,263.4,99.18,267.45,99.18,267.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.33 406.3 47.76 406.3 42.57 360.14 94.53 360.14 89.33 406.3",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.52 368.6 44.02 373.07 93.07 373.07 93.58 368.6 43.52 368.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.97 382.91 92.47 378.44 44.63 378.44 45.13 382.91 91.97 382.91",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tools--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.8,131,114.93,94.9a18.45,18.45,0,0,0,25.61-20.83L126.16,88.44a1.1,1.1,0,0,1-1.56,0L112.14,76a1.1,1.1,0,0,1,0-1.56l14.38-14.37a18.45,18.45,0,0,0-20.83,25.61L69.56,121.78A18.45,18.45,0,0,0,44,142.61l14.38-14.37a1.09,1.09,0,0,1,1.55,0L72.35,140.7a1.1,1.1,0,0,1,0,1.56L58,156.63A18.44,18.44,0,0,0,78.8,131Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.57,50.28l-11-3.61-8.63,7.72,2.38,11.34,11,3.6L153,61.61Zm-7.68,12.21-4.36-1.43-.94-4.49,3.42-3,4.35,1.42.94,4.49Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.78,294.38l-36.13,36.13A18.45,18.45,0,0,0,336,351.34L350.42,337a1.1,1.1,0,0,1,1.56,0l12.46,12.47a1.09,1.09,0,0,1,0,1.55l-14.38,14.38a18.45,18.45,0,0,0,20.83-25.61L407,303.62a18.45,18.45,0,0,0,25.61-20.83l-14.38,14.38a1.1,1.1,0,0,1-1.56,0l-12.46-12.46a1.1,1.1,0,0,1,0-1.56l14.38-14.38a18.45,18.45,0,0,0-20.83,25.61Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326,375.13l11,3.61,8.62-7.73-2.37-11.33-11-3.61-8.63,7.73Zm7.68-12.21,4.36,1.43.94,4.48-3.42,3.06-4.35-1.43-.94-4.48Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.25,131,414.38,94.9A18.45,18.45,0,0,0,440,74.07L425.61,88.44a1.09,1.09,0,0,1-1.55,0L411.59,76a1.1,1.1,0,0,1,0-1.56L426,60.05a18.45,18.45,0,0,0-20.83,25.61L369,121.78a18.45,18.45,0,0,0-25.61,20.83l14.38-14.37a1.1,1.1,0,0,1,1.56,0L371.8,140.7a1.1,1.1,0,0,1,0,1.56l-14.38,14.37A18.44,18.44,0,0,0,378.25,131Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,50.28l-11-3.61-8.62,7.72,2.37,11.34,11,3.6,8.62-7.72Zm-7.68,12.21L438,61.06,437,56.57l3.42-3,4.35,1.42.94,4.49Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88,133.68l-11-3.6-8.63,7.72,2.38,11.33,11,3.61,8.63-7.73Zm-7.68,12.21-4.36-1.42L456.9,140l3.42-3.06,4.35,1.43.94,4.49Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.67,82.6l-11-3.61-8.62,7.73,2.37,11.33,11,3.61,8.62-7.73ZM212,94.81l-4.36-1.43-.94-4.48,3.42-3.06,4.35,1.43.94,4.48Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82,342.75l-11-3.61-8.62,7.72,2.38,11.33,11,3.61,8.62-7.72ZM192.13,355l-4.35-1.43-.94-4.49,3.41-3.06,4.35,1.43,1,4.49Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.15,202.41l-11-3.6-8.62,7.72,2.37,11.33,11,3.61,8.62-7.73Zm-7.69,12.21-4.35-1.42-1-4.49,3.42-3.06,4.35,1.43,1,4.49Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.63,352.69l36.12-36.13a18.44,18.44,0,0,0,25.61-20.83L186,310.11a1.1,1.1,0,0,1-1.56,0L172,297.65a1.1,1.1,0,0,1,0-1.56l14.37-14.38a18.45,18.45,0,0,0-20.83,25.61l-36.12,36.13a18.45,18.45,0,0,0-25.61,20.83l14.37-14.38a1.1,1.1,0,0,1,1.56,0l12.46,12.46a1.1,1.1,0,0,1,0,1.56L117.8,378.3a18.45,18.45,0,0,0,20.83-25.61Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4,271.94l-11-3.61-8.63,7.73,2.38,11.33,11,3.61,8.63-7.73Zm-7.68,12.21-4.36-1.43-.94-4.48,3.41-3.06,4.36,1.43.94,4.48Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 295.89,
    width: 27.63,
    height: 111.46,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.51,
    y: 112.03,
    width: 348.66,
    height: 211.48,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.49,
    y: 112.03,
    width: 348.66,
    height: 211.48,
    style: {
      fill: "#FEE900",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 119.65,
    width: 323.53,
    height: 196.24,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 304.07,
    width: 323.53,
    height: 11.82,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.33 394.84 144.9 401.46 144.9 408.13 346.74 408.13 346.74 401.46 247.33 394.84",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.05,
    y: 119.65,
    width: 323.53,
    height: 196.24,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 462.87,
    y1: 406.3,
    x2: 21.94,
    y2: 406.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 485.77,
    y1: 406.3,
    x2: 473.9,
    y2: 406.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.33,282.83s1.66,59,2.5,69.27,3.34,37.3,3.9,42.31-.56,19.21-.56,19.21L402.78,415l1.11,7s-8.91,5.57-13.36,7.24,1.11,3.89,5,4.45A26.61,26.61,0,0,0,407,433.1c4.46-1.11,10-3.06,12-3.34S422,427,422,423.92s-.28-3.34,0-4.74-1.4-7.23-1.68-8.62,3.9-32.85,3.07-42.87-1.12-23.66-1.12-25.05-.55-15.87-.55-15.87,4.73,32,5.29,33.13,9.74,47.59,10,49.82-.84,4.73-.56,6.4,1.67,6.68,1.67,6.68-.84,7.52-3.34,10.86-3.06,6.12-1.67,7.24,4.45,1.11,8.07.28,3.62-.28,7-3.07,4.45-10.85,4.45-11.69,1.4-3.62,1.4-6.68,0-1.67-1.12-6.12-.83-21.71-1.11-31.73-3.62-30.07-3.62-34-1.67-62.08-1.67-62.08S419.77,294,398.33,282.83Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.73,424.35a11.4,11.4,0,0,1-6.84-2.38s-8.91,5.57-13.36,7.24,1.11,3.89,5,4.45A26.61,26.61,0,0,0,407,433.1c4.46-1.11,10-3.06,12-3.34S422,427,422,423.92c0-1.29-.05-2.08-.09-2.67C418.82,422.55,413.69,424.48,410.73,424.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.8,426.57c-5.05.4-10.85,6.53-18.59,5.66a31.78,31.78,0,0,1-9.81-2.45c-2.09,1.57,2.68,3.39,6.14,3.88A26.61,26.61,0,0,0,407,433.1c4.46-1.11,10-3.06,12-3.34,1.41-.2,2.38-1.58,2.81-3.48C420.82,426.34,419.56,426.43,417.8,426.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.89,426.37a12.2,12.2,0,0,1-8.76-3.57s-.84,7.52-3.34,10.86-3.06,6.12-1.67,7.24,4.45,1.11,8.07.28,3.62-.28,7-3.07,4.45-10.85,4.45-11.69a5.16,5.16,0,0,1,.31-1.24A14.9,14.9,0,0,1,446.89,426.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.15,438.11c1.48-1.23,2.53-3.51,3.23-5.74l0,.06A15.54,15.54,0,0,1,441,439.5a13.35,13.35,0,0,1-8.65-.55,2.25,2.25,0,0,0,.74,1.95c1.39,1.11,4.45,1.11,8.07.28S444.81,440.9,448.15,438.11Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.69,281.06s-.8,3.88.81,5.82,8.08,6.14,23.44,6.31S443.77,290,446,288.5s1.29-7.92,1.29-7.92a68.85,68.85,0,0,1-22.95,5.33C412.08,286.4,397.69,281.06,397.69,281.06Z",
    style: {
      fill: "#FEE900",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,210.14l-14.11-7.34s-17.27-15.12-25.76-20.73-15.69-3.74-16.27,3.17,28.64,29.79,34,34.11,6.48,6.48,6.48,6.48.72,38.57,1,44.76,0,10.36,2,12.24,11.37,7.62,24.47,6.9,19-2,21.45-4,3.88-3.74,3.88-7.19S451.87,229,451.87,229s25.91-17.7,32.53-23.6,7.06-14.25,2.74-15.12-15.26,4.47-19.58,7.2-18.13,7.05-22.88,8.35-9.5,2.73-9.5,2.73S423.23,211.86,411,210.14Z",
    style: {
      fill: "#FEE900",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 395.31,
    y1: 225.83,
    x2: 390.93,
    y2: 209.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 393.43,
    y1: 220.15,
    x2: 386.78,
    y2: 205.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 451.87,
    y1: 228.99,
    x2: 455.53,
    y2: 215.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 453.04,
    y1: 225.56,
    x2: 458.03,
    y2: 216.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 376.81,
    y1: 190.87,
    x2: 367.67,
    y2: 195.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 469.04,
    y1: 202.71,
    x2: 473.4,
    y2: 206.24,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.72,227l-3.6,23.25a.94.94,0,0,0,.79,1.07h0a.93.93,0,0,0,1.07-.79L413.3,228Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.68,227.84l-1.91,22.81a1.06,1.06,0,0,0,1.12,1.15h0a1.06,1.06,0,0,0,1-1l1.53-23.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.13,209.13s-5.18,5.76-5.61,8.06,3.6,5.18,3.6,5.18-2,.58-.58,1.87,9.79,7.78,12.24,7.78,5.47-3.89,13-5.62,12.81-9.5,12.24-13.1a3.09,3.09,0,0,0-3.75-2.88s1.44-3.16-.86-4.6-7.63-1.44-10.22-1.15S416.61,205.53,410.13,209.13Z",
    style: {
      fill: "#FEE900",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.85,223a35.46,35.46,0,0,1-2.86,2.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.22,210.42s-3.45,6.63-6,9.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 408.12,
    y1: 222.37,
    x2: 411.72,
    y2: 224.39,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.88,191.28c-1.58-1.44-5.61-5.47-2.44-10.36s8.06-3.17,12.09-3.17,33.1,7.05,33.1,7.05,6.19-10.65,7.49-12.52,6.33-2,6.33-2,1.15.43.58,1.87-1.59.72-1.87,4-1.88,15.11-4.61,16.55-9.93-.29-9.93-.29L365.94,194",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.94,194l14.06-.69a7.27,7.27,0,0,1-2.54-5.5A14.14,14.14,0,0,1,380,180c-5.8-1.27-11-2.29-12.49-2.29-4,0-8.93-1.73-12.09,3.17s.86,8.92,2.44,10.36",
    style: {
      fill: "#FEE900",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.72,171.27s-6,11.95-5.75,13.39,1,3.17,1,3.74-3.16,7.92-2.59,9.93,3,11.38,5.33,14.69,3.88,3.31,3.88,3.31-1.15,7.91-.28,10.22,3.74,6,5.47,5.47,11.22-11.66,12.09-15,1.87-14.69,1.87-14.69,1.73-3.16,2.73-4.6a22.78,22.78,0,0,0,5.19-13.39c.28-7.48-6.91-14.39-13.39-16.26S415,170,412.72,171.27Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.57,189.84s-3.16,7-2.59,7.34a6,6,0,0,0,5,1c2.73-.72,2.73-2.16,2.73-2.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.37,204.81c.4,1,.2,2.08-.43,2.32s-1.46-.41-1.86-1.45-.2-2.08.43-2.32S414,203.77,414.37,204.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.59,216.33s2.16-.29,3.89-.72,8.64-6.19,8.64-6.19L414,224.53Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.91,183.65s3.75-2.3,5.76,2.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.87,183.8a2.94,2.94,0,0,0-4,.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.22,190.35c0,.83-.42,1.51-.94,1.51s-.94-.68-.94-1.51.42-1.52.94-1.52S421.22,189.51,421.22,190.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.05,
    cy: 189.57,
    rx: 0.86,
    ry: 1.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.16,200.92a15,15,0,0,0,1.76,1.12c.47-.85,1.74-3.12,2.55-4.28a22.78,22.78,0,0,0,5.19-13.39c.28-7.48-6.91-14.39-13.39-16.26a17.1,17.1,0,0,0-10.56.81c.19.37.85.79,2.64,1.06,3.89.57,8.49-1.3,10.94.43s3.46,6.91,1.3,8.78-6.62,4.89-4.75,7.34a15,15,0,0,1,2.88,5.47c0,.58-.87,1.15,0,1.3s2,.43,2.44-.87,2.74-3.31,3.89-1-.29,5-1.58,6.76A10.58,10.58,0,0,1,432.16,200.92Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.08,204.67l-11.37-.43s-33.4-8.21-35.84-9.5-1.87-5-2.16-5.91-1-4.75-.29-5.75,6.77-5.62,7.2-6.19-.72-3.31-.43-4,1-.87,1.72-.43a1.92,1.92,0,0,1,.87,1.15s1.44.28,2.73,2.59,1.58,4.17,1.3,5,1.29,2.59,1,3.88a28.16,28.16,0,0,1-2.15,4.61s27.2-1.15,31.81-1.15,15.4-.58,16.69,2,0,7.05-2.16,10.08",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 441.66,
    y1: 189.7,
    x2: 437.67,
    y2: 189.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.78,173.58s1.8,3.58,1.38,4.62l-.41,1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.81,181.21a20.14,20.14,0,0,1-2.65,2.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488,200.64c2.16-3,3.46-7.49,2.16-10.08s-11.94-2-16.6-2a10.11,10.11,0,0,1,.19,7.77c-1.28,3.67-4.89,6.22-7.35,7.59l1.31.33,11.37.43",
    style: {
      fill: "#FEE900",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Smoke--inject-1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M244,166.67a12.31,12.31,0,0,0,1.42-5.73,12.82,12.82,0,0,0-25.64,0,12.48,12.48,0,0,0,5.43,10.27,9.61,9.61,0,0,0-5.66,15.62,13.08,13.08,0,0,0-7.17,11.37c0,7.36,6.71,13.34,15,13.34s15-6,15-13.34a12,12,0,0,0-1.11-5q.73.06,1.47.06c8.58,0,15.54-6,15.54-13.31C258.22,173,252,167.24,244,166.67Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 216.55,
    cy: 142.21,
    r: 8.14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194.61,131.6a2.47,2.47,0,1,0,2.46,2.47A2.48,2.48,0,0,0,194.61,131.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M244.41,137a6.91,6.91,0,1,0-6.9-6.91A6.9,6.9,0,0,0,244.41,137Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.58,83a2.47,2.47,0,1,0,2.47,2.46A2.46,2.46,0,0,0,267.58,83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.3,62.2a8.14,8.14,0,1,0,11,3.44A8.13,8.13,0,0,0,262.3,62.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M317,118a12.31,12.31,0,0,0,1.42-5.73,12.46,12.46,0,0,0-5.09-10c6.07-3.37,9.31-9.65,8.33-15.35a6.9,6.9,0,1,0-9.69-9.66,16.77,16.77,0,0,0-10.21,1.1,12.27,12.27,0,0,0-1.4-5.73,12.82,12.82,0,0,0-22.72,11.89,12.35,12.35,0,0,0,4.87,5,8.08,8.08,0,0,0-1.07,4,8,8,0,0,0,.42,2.55,11.17,11.17,0,1,0-2,22.07,11.18,11.18,0,0,0-1.95,12.53A11.17,11.17,0,0,0,285.42,151c.8,6.7,7.16,11.92,14.89,11.92,8.28,0,15-6,15-13.34a12.15,12.15,0,0,0-1.1-5q.72.06,1.47.06c8.58,0,15.53-6,15.53-13.31C331.19,124.3,324.92,118.59,317,118Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.71,70.19a2.47,2.47,0,1,0,3.33,1A2.46,2.46,0,0,0,241.71,70.19Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M288.35,51.91A6.9,6.9,0,1,0,279,49,6.9,6.9,0,0,0,288.35,51.91Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screws--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.48,174.83a6.88,6.88,0,1,0-6.88,6.88A6.88,6.88,0,0,0,215.48,174.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 213.56,
    y1: 169.9,
    x2: 204.16,
    y2: 179.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.33,247.37a6.88,6.88,0,1,0-6.88,6.88A6.88,6.88,0,0,0,279.33,247.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.88,174.83a6.88,6.88,0,1,0-6.88,6.88A6.88,6.88,0,0,0,336.88,174.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 334.96,
    y1: 169.9,
    x2: 325.56,
    y2: 179.3,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.63,409.82l-24,8.34a1.82,1.82,0,0,0-1.21,1.94h0a1.83,1.83,0,0,0,1.93,1.6L245,420.23Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 220.39,
    y1: 421.7,
    x2: 224.34,
    y2: 416.85,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.88,
    y1: 421.35,
    x2: 230.07,
    y2: 415.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 229.39,
    y1: 421.23,
    x2: 236.52,
    y2: 412.48,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.12,
    y1: 420.97,
    x2: 242.57,
    y2: 410.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.83,414.46a6.88,6.88,0,1,0-6,7.66A6.88,6.88,0,0,0,251.83,414.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.33,
    y1: 409.79,
    x2: 241.13,
    y2: 420.25,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear-2--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M368.47,408.46l-2.39,3c-.28-.18-.56-.36-.88-.53a28.75,28.75,0,0,0-3.42-1.62l6-1.78,2.32-.54v-.15h.05l-.05,0v-6.59l-11.44,2.19,2,1.69-.9-.26-8.38,2.49c-3.52-.72-2.27-3.53-6.31-3.92l-3.38-1.21-14.39-.64-2.41.06c-5-2.88-9.6-3.22-11.83,4l-5.56-3.11-6.78,1,3.83-2.9-9.92-2.94v6.77L287,404.72H274.16v6.77l10.77,1.58a7.24,7.24,0,0,0-1,1.17l-10.18.49-2.46-4.2v6.77l2.46,4.19,9.41-.45v5.67l10.4,3L302,427.2a110.36,110.36,0,0,0,11.39,1.66l-1.7,3.47,14.39.64,1.72-3.47c4.19,0,8.41-.21,12.53-.6l5.56,3.11,12.86-1.95-1-4.3c1.54-.46,3-.94,4.23-1.46l10.72,1.58,6.44-3.8V416.4l2.84-.13V409.5Zm-70.54-3.1,2.25,1.26c-1.41.31-2.73.65-4,1Zm45.61,18v-3.43l-3.87.11v-.5l-4.09.63c-7.56.22-17.84.53-18.2.53l-.85,1.73c-6.07.32-11.36-.06-14.62-1.89-7.19-4-1.94-8.94,11.74-11s30.58-.48,37.77,3.53C357.88,416.65,354.27,421,343.54,423.34ZM376,417.21l-4-.46,5.23-.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.66 394.47 338.37 399.51 341.66 398.7 341.66 394.47",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.67,417.28c-13.67,2.07-30.58.49-37.76-3.52s-1.94-8.95,11.74-11,30.58-.49,37.77,3.52,1.93,8.94-11.75,11m-32.2-22.5-12.87,2,5.58,3.12a56.76,56.76,0,0,0-8.86,2.64l-10.72-1.57-6.44,3.79,10.77,1.58a5.12,5.12,0,0,0-1.81,3.67l-11.8.56,2.46,4.2,11.83-.57a16.55,16.55,0,0,0,2.51,1.69,28.76,28.76,0,0,0,3.42,1.61l-8.35,2.48,10.4,3,8.38-2.49a113.15,113.15,0,0,0,11.41,1.66l-1.72,3.46,14.39.64,1.72-3.46c4.19,0,8.41-.22,12.53-.61l5.56,3.11,12.86-1.94-5.58-3.12a57.86,57.86,0,0,0,8.86-2.64l10.72,1.57,6.44-3.79-10.77-1.58a5.13,5.13,0,0,0,1.81-3.67l11.8-.57-2.46-4.19-11.83.56a16.55,16.55,0,0,0-2.51-1.68,30.4,30.4,0,0,0-3.42-1.62l8.36-2.48-10.41-3-8.38,2.49a110.37,110.37,0,0,0-11.41-1.66l1.72-3.46-14.39-.65-1.72,3.47c-4.19,0-8.41.22-12.52.6l-5.56-3.11",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears-1--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.75,244.13a36.07,36.07,0,0,0-.39-5.23l9.22-3,1.26-3-2,.59-2.85-8.78-9.25,3a35.57,35.57,0,0,0-6.07-8.31l5.7-7.85,1.26-3-2,2.46-8.77-6.37-5.72,7.87a35,35,0,0,0-9.8-3.16v-9.7H207.5l-.76-3-1.25,3v9.73a35,35,0,0,0-9.79,3.2L190,204.7l-6.41,4.66-1.87-.75-.2.49-1.06,2.53,5.73,7.87a35.33,35.33,0,0,0-6,8.34l-6.19-2-1.78-4-1.26,3-3.64,11.2,9.25,3a35.28,35.28,0,0,0-.37,5.07,36.07,36.07,0,0,0,.39,5.23l-5,1.63-2.94-1.65-1.25,3L171,263.56l9.25-3a35.46,35.46,0,0,0,6.08,8.32l-3.55,4.87-.9,0-1.26,3,9.53,6.93,5.72-7.87a35.37,35.37,0,0,0,9.8,3.16v9.7h11.78l1.26-3h-1.26v-6.72a34.94,34.94,0,0,0,9.79-3.2l5.7,7.84,9.54-6.92,1.25-3-2.55,1.23-4.42-6.09a35.37,35.37,0,0,0,6-8.34l9.23,3,3.64-11.2-9.25-3A35.39,35.39,0,0,0,246.75,244.13ZM211.46,266.8a22.67,22.67,0,1,1,22.66-22.67A22.67,22.67,0,0,1,211.46,266.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.25,260.4l3.64-11.21-9.25-3a36.93,36.93,0,0,0,.36-5.08,35.93,35.93,0,0,0-.38-5.22l9.22-3-3.64-11.21-9.25,3a35.46,35.46,0,0,0-6.08-8.32l5.71-7.85L234,201.6l-5.71,7.86a35.09,35.09,0,0,0-9.81-3.15v-9.7H206.74v9.73a35,35,0,0,0-9.79,3.2l-5.7-7.85-9.53,6.92,5.72,7.88a35.62,35.62,0,0,0-6,8.34l-9.22-3L168.54,233l9.25,3a35.39,35.39,0,0,0-.37,5.07,34.61,34.61,0,0,0,.39,5.23l-9.23,3,3.65,11.21,9.25-3a34.88,34.88,0,0,0,6.07,8.31l-5.7,7.86,9.53,6.92,5.72-7.87a34.62,34.62,0,0,0,9.8,3.16v9.7h11.78v-9.73a35,35,0,0,0,9.79-3.2l5.7,7.85,9.53-6.93L238,265.74a35.33,35.33,0,0,0,6-8.34Zm-63.2-19.29a22.67,22.67,0,1,1,22.66,22.67A22.66,22.66,0,0,1,190.05,241.11Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.17,181.45a34.71,34.71,0,0,0-.39-5.23l9.23-3,1.25-3-2,.59L313.37,162l-9.25,3a35.61,35.61,0,0,0-6.08-8.31l5.71-7.85,1.25-3-2,2.46-8.77-6.37-5.71,7.87a35.11,35.11,0,0,0-9.81-3.16v-9.7h-9.77l-.75-3-1.26,3v9.73a35,35,0,0,0-9.79,3.2l-5.7-7.85L245,146.68l-1.86-.74-.21.48L241.89,149l5.72,7.87a35.19,35.19,0,0,0-6,8.35l-6.19-2-1.78-4-1.25,3-3.64,11.2,9.25,3a35.39,35.39,0,0,0-.37,5.07,34.71,34.71,0,0,0,.39,5.23l-5,1.63L230,186.66l-1.26,3,3.64,11.2,9.26-3a35.28,35.28,0,0,0,6.07,8.31l-3.54,4.88-.91,0L242,214l9.53,6.93,5.71-7.87a35.11,35.11,0,0,0,9.81,3.16V226h11.78l1.26-3h-1.26v-6.72a35,35,0,0,0,9.79-3.2l5.7,7.85,9.53-6.93,1.26-3-2.56,1.22-4.42-6.08a35.19,35.19,0,0,0,6-8.35l9.23,3,3.64-11.2-9.26-3A35.39,35.39,0,0,0,308.17,181.45Zm-35.29,22.67a22.67,22.67,0,1,1,22.67-22.67A22.67,22.67,0,0,1,272.88,204.12Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.67,197.72l3.64-11.21-9.25-3a35.39,35.39,0,0,0,.37-5.07,36,36,0,0,0-.39-5.23l9.22-3L314.62,159l-9.25,3a34.88,34.88,0,0,0-6.07-8.31l5.7-7.86-9.53-6.92-5.72,7.87a34.72,34.72,0,0,0-9.8-3.16v-9.7H268.17v9.73a35,35,0,0,0-9.79,3.2l-5.7-7.85-9.53,6.93,5.72,7.87a35.33,35.33,0,0,0-6,8.34l-9.23-3L230,170.36l9.25,3a35.42,35.42,0,0,0-.37,5.08,35.93,35.93,0,0,0,.39,5.22l-9.22,3,3.64,11.21,9.25-3a35.46,35.46,0,0,0,6.08,8.32L243.27,211,252.8,218l5.72-7.86a35.13,35.13,0,0,0,9.8,3.15v9.7h11.79v-9.72a34.89,34.89,0,0,0,9.78-3.21l5.71,7.85,9.53-6.92-5.72-7.88a35.58,35.58,0,0,0,6-8.34Zm-63.2-19.28a22.67,22.67,0,1,1,22.67,22.66A22.67,22.67,0,0,1,251.47,178.44Z",
    style: {
      fill: "#bdbdbd",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.23 256.29 296.32 256.29 297.83 254.92 296.23 256.29",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.52,261l-.48.25C294.06,261.38,294.15,261.39,294.52,261Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.35,259.27c.14-.18-1,1-1.38,1.48C294.35,260.57,295.43,259.56,295.35,259.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.75,263.56l4.23-1.37c.32-.32.49-.6.26-.76-.72,1-.63.36-1.15.73v.09c-.13.09-.52.36-.37.09a24.15,24.15,0,0,0,2.94-2c-.42.22.12-.61.14-.76.8-.65.21.19.3.38.4-.37,1.28-.73,1.35-1.29.34-.74-.88.45-1.23.45l2.48-1.83h-.12a1.77,1.77,0,0,0,.8-.65c.05-.37-.49.09-.77.46.89-1.38,2.52-1.45,3-2.91l-.38.24c.14-.19.27-.27.39-.27s0,0,0,0l.77-.48c0-.1,0-.29-.09-.2l.77-.45c1.31-1,0-.66.28-1.12l-.06.06c.3-.41.42-.83.13-.62l1.43-1h0c-.16,0-.29,0-.32-.1l.32.1c.77-.18,2.62-1.89,3.13-1.34a2.43,2.43,0,0,0,.14-.2c0-.1-.05-.21-.07-.32a2.12,2.12,0,0,1-.4.33l.4-.33a22.83,22.83,0,0,1-.4-3.54c-.33.27-.57.51-.58.69l.14-.08-.05.28a.2.2,0,0,1-.09-.2c-.95.57-1.64,1.51-2.39,2l.2.28a5.41,5.41,0,0,0-1.18.92s.11,0,.21,0l.55-.43a1.26,1.26,0,0,1-.55.43A40.83,40.83,0,0,0,303.4,252c.22.1.32.2,1-.35-.75,1.2-2.89,2.28-4.28,3.85h.22l-1,.63c.25-.09.22.1.33.2-1.38,1.47-3.15,3.22-4.36,3.48.51-.28-.36.93.66.29a24.23,24.23,0,0,0-3.37,2.82Zm7.83-5.91.93-.73-.95.92Zm-2.41,2.21-.82.82-.51.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,261.29c0-.19.26-.71-.4.2Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.09,258.22l1.66-1-.62.27,1-.73C295.83,256.66,294.69,257.29,294.09,258.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,258.14a2.12,2.12,0,0,0-.51.37A3.17,3.17,0,0,1,295,258.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,258.14c.21-.06-.06.39.6-.07C295.59,257.88,295.32,258,295,258.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.6,283.44l.51-.78C328.37,282.62,328.71,283.05,328.6,283.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.69 256.31 296.32 256.29 296.22 256.38 296.69 256.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.19,218.46c.41-.17,1.05-.19,1.27-1C337.69,217.52,337.85,218.09,337.19,218.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.44,283.7a.49.49,0,0,0,.16-.26Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.53,210.1l-.16,0c-.15.27-.22.49-.14.52A1.24,1.24,0,0,1,342.53,210.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.29,221h-.24c1.43-1,2.54-3.05,3.78-4.42,0,.18-1.08,1.09-.64,1.29l1.74-1.56c0-.18.71-.92.09-.65a2.67,2.67,0,0,0-.56.64l.05-.37c1.72-1.37.39.57.71.85.71-.92,1.3-.91,1.85-1.46-.05-.56-1.4.73-1-.3a7.57,7.57,0,0,1,3-2.28,2,2,0,0,1,.33-.89c-.45-.2-.91-.39-1.37-.57-2.54,2.34-5.47,3.94-7.44,7.05h.11l-2.19,1.46c-.29.37-.1.75-.55,1.39,0-.3-.34,0-.73.4.74.07,1.46.17,2.17.3A2.94,2.94,0,0,1,338.29,221Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.68,254.3c.28-.37-.06-.47.71-.93.08.29.75.49,1.49-.53a6.15,6.15,0,0,0-2.26,1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,253.45l1-1.25C301.8,252.41,302.1,252.89,301.81,253.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.81,253.45l-.31.41A1.34,1.34,0,0,0,301.81,253.45Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "310.82 240.73 310.83 240.73 310.83 240.72 310.82 240.73",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.23,222.67l-.21-.26c-.15.13-.3.27-.46.43C360.58,223.08,360.93,222.88,361.23,222.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.41,259.13c.37-.58.83-.45,1.15-.77-.09-.26-.37-.14-.59-.12-.21.26-.41.51-.63.76A.24.24,0,0,0,350.41,259.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.52,258.07c0-.21.37-.57.67-1C351.73,257,351.32,258,351.52,258.07Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.67,265.93c-.33.18-1.15.08-1.41.83l.5-.26-.07.11.28.08C344.38,266.32,345.43,266.14,345.67,265.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.13 231.16 353.68 231.81 354.08 231.44 354.13 231.16",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.65,251a10,10,0,0,1-1.13,1l.19.29a5.54,5.54,0,0,0-1.18.91.26.26,0,0,0,.21,0l.56-.44a1.33,1.33,0,0,1-.56.44,42.25,42.25,0,0,0-3.46,3.13c.22.1.33.2,1-.35-.75,1.2-2.9,2.28-4.29,3.85h.23l-1,.63c.25-.08.22.11.32.2l-.27.28a35.45,35.45,0,0,0,5.84,7.9l-5.7,7.85,9.53,6.93,5.71-7.87a35.44,35.44,0,0,0,9.81,3.16v2.29a.79.79,0,0,0,.32-.64l-.25.11c.08-.12.16-.16.25-.14s0,0,0,0l.51-.22c0-.08,0-.22-.11-.18l.51-.19c.83-.52-.16-.53,0-.83l0,0c.15-.26.16-.56,0-.46l.92-.49h0a.31.31,0,0,1-.27-.15l.27.15c.57,0,1.68-.95,2.2-.41.14-.23.2-.47,0-.47l0,0a.83.83,0,0,1-.3.22l.3-.22,0,0h0c.56-.49-.53-.29.39-1.05-.1-.1-.17,0-.34.11.21-.23.33-.29.43-.27a.49.49,0,0,1-.14-.27c.2.2.51-.2.65-.43l-.63,0a1,1,0,0,0,.83-.52h-.45c.65-.5.5.42,1-.46l-.42.84c.8-.66,1,0,1.5-.13,1.11-.43,1.44-2,2.7-1.9-.13-.31-.3-.29-.27-.69a1.85,1.85,0,0,1-1.46.47c-1.26.61.59,1.06-.95,1.58-.22-.33.09-.66.52-.81-.22-.27-.73-.07-1.07,0,.72-.46,1.27-1.61,1.67-2h-.05l.09,0,0,0a1.9,1.9,0,0,0,1.09-.62s0-.09,0-.2a.18.18,0,0,1,0,.2c.15.22,1.21-.57,1.3.09.73-.54-.13-.92.92-1.1-.55-.09.19-.64-.35-.65.06.49-1.07.72-1.59.85l.75-1.09c-.14.31.38.18.55.09l-.14-.38c.78.49,1.16-2.07,2.36-1.8-.33.25-.36.72-.83.52-.35.72.59.37.56.84,1.09-.58,1.94-2.26,3.31-2.69-.36,0-.75.41-1.05.18.52-.81,1.92-1,2.92-1.56l-.47-.2c.94-.36.13-.38.94-1,0,.07,0,.29.2.12.55-.59-.22-.33.07-.79.59-.1.61-.26.61-.48A22.66,22.66,0,0,1,311.65,251Zm33.11,12.8c.4.24-.5.88-.64,1.18C343.87,264.46,344.86,264.54,344.76,263.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.24,224a1.25,1.25,0,0,0,.14-.31C361.26,223.84,361.23,223.93,361.24,224Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,224.14a.52.52,0,0,0,.35-.15A.68.68,0,0,0,361.46,224.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.46,224.14c-.12,0-.2,0-.22-.13a16.67,16.67,0,0,1-2.54,2.92c-.18.47,1-.26,1.35-.44-1.23-.4,1.08-1,1.45-1.94-.25.09-.67.55-.9.54A3,3,0,0,1,361.46,224.14Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.52,283a6,6,0,0,0-1.09.11v0l0,0A.59.59,0,0,0,328.52,283Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.26,224.6l1.62-1.56c-.41-.39-.67.64-1.15.73.07-.53.7-1,1.23-1.44a37.68,37.68,0,0,0-2.56-2.94l5.7-7.85-6.86-5c-.59.56-1.27,1.33-2,1.91l.21.19-.78.55.36-.09c-.67.64-1.79,1.09-2.38,2,.42-.55.86-.35.95-.16l-2.34,1.64c.09.19-.74,1.11,0,.66l-1,.54.22.1c-2.82,3.41-6.67,4.93-9.07,8.73h.11l-.4.27a22.74,22.74,0,0,1,11.26,9.18,16.57,16.57,0,0,0,3-2.49c-.23,0-.64.36-.75.36,1.19-1,3.29-1.72,3.57-2.93-.68.34-1.48.76-2.21,1.16a.71.71,0,0,1-.39.22c-.46.26-.89.5-1.21.7.59-.81.88-.64,1.21-.7l.39-.22a2.72,2.72,0,0,0,.51-.73l-.61.18c1.25-1.39,1.48-.53,2.48-1l.51-1.11a12.27,12.27,0,0,1,2.61-2.51l-.23-.28C360.66,223.36,359.9,224.37,359.26,224.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.57,271.18l-.2.17A.5.5,0,0,0,339.57,271.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,271.42c.17.22.19.12.39-.07-.3.14-.58-.19-.8.37C338.74,271.7,338.8,271.44,339,271.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.48,269.93c-.18-.66-1,.28-1.25.74C339.49,270.61,340,269.66,340.48,269.93Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.34 269.48 339.39 269.83 339.7 269.44 339.34 269.48",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.75 266.2 343.26 265.93 343.25 265.86 342.75 266.13 342.75 266.2",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.37,270.06c-.49-.34-.2.49-.8.66.2.2.68-.21.95-.21.15-.23-.28-.15-.47-.2A.78.78,0,0,1,342.37,270.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.05,272l-.18.16A.32.32,0,0,0,341.05,272Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.05,272l.3-.25C341.13,271.59,341.15,271.82,341.05,272Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.86,216.69l.41-.46c-.44.65,1-.36.28.57-.29.37.75-.36,1.05-.83-.22-.1-.92.73-.86.27l.29-.37C338.6,216.43,338.34,215.76,337.86,216.69Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.58,251.54c-.25.14-.34.11-.46.56C360.37,252,360.6,251.68,360.58,251.54Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.74,256c-.08,0-.63.64-.83.45l.15.45c.22-.35.75-.4.68-.22C353.78,256.25,354.12,256.15,353.74,256Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.33,252c-.22.34-1,.39-.78.87l.74-.47C357.27,252.17,357.61,252.07,357.33,252Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.53,244.13a34.71,34.71,0,0,0-.39-5.23l9.23-3-3.64-11.2-9.25,3c-.53-1-1.11-1.94-1.72-2.88a3.24,3.24,0,0,1-1.07.86c0,.18.4-.28.23.1-2,1.93-5.32,4.48-7.44,7.07-.3-.15-.76.08-1.31.48A22.65,22.65,0,0,1,352,256.91a1.7,1.7,0,0,1,.63-.17c-.24-1.17,1.71-2,1.18-2.54,0,.07.38.1.52-.2H354c.41-.91,1.14-.16,1.43-.69-.11-.09-.27,0-.46-.06.76-1,2.05-.72,2.61-1.93-.1,0-.19-.05-.26.06s.06-.18.49-.34l-.11.52c1.1.17,1-1.51,1.87-2.07-.19,0-.74.48-.62,0,.47-.48,1.1.25,1.34-.65-.33.18-.57-.21-.88,0a1.52,1.52,0,0,1-.25.26.78.78,0,0,1,.25-.26c.33-.41.4-.86.78-.75a.28.28,0,0,0,0-.34.37.37,0,0,1-.18,0c0-.08.11-.06.18,0,.43,0,.67-.56.86-.86l-.18-.06c1.1.18.79-.73,1.44-1.3l-.28-.08c.33-.18.94-.35,1.11-1.05h-.45c.51-.2.83-1.2,1.46-1.16.07-.19-.73-.07-.18-.67.27,0,.86-.3.81-.66-.1-.1-.29-.15-.34.11-.08.11,0,.07.1.1l-.36,0c.28-.6.52-.2.88-.77,0-.22-.36,0-.54-.09l2.14-1.38c.2.12.06.43.42.46l-.54.67c0,.55.63,0,1-.21l-.39.44a.07.07,0,0,0,.1,0l-.32.3c1.19-.49-.36,1.34.81.71a1.62,1.62,0,0,1-.95.28c-.49.34-.21.41-.27.67l.85-.37c-1.05.86.38.18-.13,1.06-1,.61-.65,1.87-1,2.31-.88.77,0-.62-.65-.26-.49.41,0,.4-.27.75l-.55-.16c-.57.46.31.36-.11.52-.19.63.27,0,.65.18-.18,0-.76.33-.81.66.1.1.66-.43.35,0-1.46,1.09-1.37,1.81-2.56,2.9l.28.08c-.17.09-.35.11-.41.3l.18,0a16.75,16.75,0,0,0-2.25,1.89l.6-.17-.93.43.4.24c-.55-.08-1.14.91-1.87,1.46l.21.19-.51.27h.27c-.39.37-1.18.48-1.46,1.09.22-.35.61-.1.72.07l-1.5.81c.11.16-.35.72.16.52l-.69.21.2.13c-1.51,2.1-4.23,2.49-5.33,5l.09,0-1.43.68c-.15.24.08.57-.14,1-.15-.45-.64.57-1.09.51-.13.38.2.2.39.25-.72,1.31-2,1.62-2.92,2.94a11.36,11.36,0,0,1,1.39-2.35c-1.07.73-.92,1.18-2,2.05l.59-.32c-.06.95-1.72,1.23-1.37,1.88-.64.5-1.63.49-2.24,1.28l.73.14-.63.64-.31-.29c-.22.19-.27.35-.22.45a1.52,1.52,0,0,1,.47,0c-.22.12-.41.09-.47,0-.77.09-1.19.89-2.06,1.23l.09.21c.1,0,.18,0,0,.17l0-.17a1.15,1.15,0,0,1-.24,0c.15.38-.43.76-.21,1,.25-.14.83-.45.63-.57.79-.19-.43.76-.74,1.08.2-.48-.28-.07-.53.06,0,.07.09,0,.18.06-.43.76-1.4.21-1.28,1.14l-.38-.18-.27.68c-.6-.52-.72.61-1.32.17-.55.53.39.25.14.38-.39.62-1.78,1-1.69,1.43l.09,0,0,.22a.32.32,0,0,1-.12-.18c-.63.25-1,.84-1.46,1.1l.21.27a1.88,1.88,0,0,0-.74.47.23.23,0,0,0,.17,0l.34-.23a.46.46,0,0,1-.34.23,15.08,15.08,0,0,0-2.08,1.75c.2.13.3.23.71-.07-.34.8-1.81,1.2-2.58,2.15l.18,0-.43.18v.26a.19.19,0,0,0,.06.07l-.06.06v3.3h11.78v-9.73a35,35,0,0,0,9.79-3.2l5.7,7.84,9.53-6.92-5.72-7.88a35.13,35.13,0,0,0,6-8.34l9.22,3,3.65-11.2-9.26-3A35.39,35.39,0,0,0,368.53,244.13Zm-10.67,6.43c.44-.69.15-.16.8-.66Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,244.13a34.71,34.71,0,0,0,.39,5.23l-9.23,3,2.83,8.7a10.84,10.84,0,0,0,2.12-2.64l-1.54.91c.71-.83,2.37-1.83,1.84-2.22-.73,1-.64.36-1.16.73v.09c-.13.09-.52.36-.37.09a24.24,24.24,0,0,0,2.95-2c-.43.22.11-.61.13-.76.8-.65.21.19.3.38.4-.37,1.28-.73,1.36-1.29.33-.74-.89.45-1.24.44L298.8,253h-.12a1.84,1.84,0,0,0,.8-.65c0-.37-.48.09-.77.46.89-1.38,2.52-1.45,3-2.91l-.38.24c.15-.19.27-.27.39-.28v0l.77-.49c0-.09,0-.28-.08-.19l.76-.45c1.32-1,0-.66.28-1.13l-.06.06c.3-.41.42-.82.13-.61l1.43-1h0c-.16,0-.28,0-.32-.1l.32.1c.77-.18,2.62-1.9,3.13-1.34.29-.37.44-.72.22-.66l-.06.06a2.7,2.7,0,0,1-.48.41l.48-.41s0,0,.05-.06h0c.94-.86-.62-.19.91-1.57-.1-.1-.24.09-.5.27.37-.39.56-.51.68-.52a.39.39,0,0,1-.1-.31c.21.19.77-.46,1.06-.83l-.85.18a2.77,2.77,0,0,0,1.31-1l-.61.17c.51-.43.65-.36.78-.32a22.67,22.67,0,0,1,19.55-18.48,1.24,1.24,0,0,0,.45-.76c.21.09,0,.4-.31.75q.3,0,.6-.06l-.15,0c1.41-.82.32-.56,1.64-1.66,0,.09-.05.38.23.1,1-1-.19-.38.38-1.12,1.75-.72.25-.93,2.07-2.21h-.23c1.43-1,2.53-3,3.77-4.42,0,.18-1.08,1.09-.64,1.29L340,212c0-.18.71-.92.09-.65a2.67,2.67,0,0,0-.56.64l.06-.38c1.71-1.36.39.58.7.86.71-.92,1.3-.91,1.85-1.46,0-.57-1.4.73-1-.3a3.18,3.18,0,0,1,.67-.76c-.92-.22-1.84-.42-2.78-.58v-9.7H327.27v9.73a35,35,0,0,0-9.79,3.2l-5.7-7.85-9.53,6.93L308,219.5a35.33,35.33,0,0,0-6,8.34l-9.22-3-3.65,11.2,9.26,3A35.28,35.28,0,0,0,298,244.13Zm-5.75,15-.83.08C292,258.74,292.33,259,292.2,259.12Zm2.26-2.77-.51.27,1.33-1.09Zm3.21-2.84,0-.19.92-.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.58,261.78c-.2-.13-.58.38-.63,0l.15-.23c-.22.34-.56-.23-.75.4l.23-.28c-.21.42.71-.07.34.51C349.77,262.44,350.44,262.08,350.58,261.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.69,247.75l.09,0a.63.63,0,0,1,.07-.27C361.75,247.52,361.66,247.57,361.69,247.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.85,245.29l.25-.13c.13-.38-.3-.22-.54,0C364.66,245.17,364.67,245.31,364.85,245.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.7,251.78c.41-.29.74.14.93-.42C361.31,251.61,361,251.11,360.7,251.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.16,247.12c.22,0,.75-.26.89,0,.28-.46.57-.93-.11-.82l-.3.4c.16-.17.17-.09.26-.07C361.77,247,361.41,247,361.16,247.12Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.08,247.38a.32.32,0,0,0,0-.25l-.2.37C362,247.48,362.05,247.47,362.08,247.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,262.71c-.6-.11-.36.37-.8.52C349.48,263.19,350,263.3,350,262.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,205.08a.3.3,0,0,1,0-.1l-.19-.14c-.49.39-1.15.71-1,1.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.12 260.62 299.2 260.62 300.72 259.25 299.12 260.62",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,261.82l1-.73a2.64,2.64,0,0,0-1.68,1l.92-.3.35-.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.33,222.6l.16.05a1.16,1.16,0,0,0,.86-.86C340.7,221.84,340.7,222.25,340.33,222.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.49,220.3c-.22-.09-.92.73-.86.27l.29-.37c-.43.56-.69-.1-1.17.82l.41-.45c-.44.64,1-.37.28.56C341.15,221.5,342.19,220.77,342.49,220.3Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.39,258.19a1.44,1.44,0,0,0,.31-.4Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.76,257.17a6.36,6.36,0,0,0-2.25,1l.05.47c.29-.37-.05-.47.72-.93C303.35,258,304,258.19,304.76,257.17Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.57,204.61l-.34.47a5.6,5.6,0,0,0,.49-.36Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7,257.79l1-1.26C304.69,256.74,305,257.22,304.7,257.79Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.94,212.07c-.15.09-.27.14-.33.08l0,.57a2.16,2.16,0,0,1,.59-.52Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.12,214.92c0-.28.71-.92,1.27-1.57C345.8,213.34,344.89,214.82,345.12,214.92Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.58 260.64 299.2 260.62 299.1 260.72 299.58 260.64",
    style: {
      opacity: 0.2
    }
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMaintenance);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/maintenance.9be13e9076da5802955401fe6f8e885f.svg";